import { WalletType } from '@web3/base-utils';

export const BANNER_TITLE_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-4cb72d7c59f043588a53888049f9912f.png';

export const BANNER_VIDEO_URL =
  'https://s3-figma-videos-production-sig.figma.com/video/1000341318267763957/ORG/2c6b/6bf1/-249c-42e5-a938-268d3f4c6c1d?Expires=1725840000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=BeC88DSF6F~Bz5Dqm2jOrDYG6-qX4fPzB1aT4puXau3FCTEW~bfXIKHYB0b1OxcwCAtvsgudiPeXRd3aVvR8E5RpCRHBDLPrGd8HnuolWw9HU46llO3-2ZYA03tSPX8zLBHg3jlXoJJ5bhf8n~dZniMfcgxhHSkb4tT3HEBurRD4kqxoacQ5~wgJL5efxhZRmg8s3nAkEuGtIYoGeyob~KuOVH9IAERThz7zDb1k4-Z1-ztXdjyDfn-am4NTY7Yifo8~Hs1rJ1qt9bIq-Jjnm~nVQH~DjJHUfcuZlicUw6O1kWkVcgK~Vn0sh8WasTEG8T~yVsMEXy~wVSdy6doL9w__';

export const PRICE_POOL_ICON_LEFT_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-2df4e99e184f40e09116f98486412101.png';
export const PRICE_POOL_ICON_RIGHT_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-660c6a5cd9c5411d95feba519add21df.png';

export const PRICE_POOL_CONTENT_SIDE_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-42bc306a50ac405c9bd1427e2a4b66ad.svg';

export const STEP_LIST_ICON_1_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-da8db6af311e4d83b7a15656723a592e.png';
export const STEP_LIST_ICON_2_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-99d27b03d93a47b5b0aeab15e8ab42c5.png';
export const STEP_LIST_ICON_3_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-5dc048cd1f91429e956b115678c851f9.png';
export const STEP_LIST_ICON_4_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-a5ffa2960569499596443b0f9787d5a4.png';

export const PROJECT_STEP_BG_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-c14aff2494694596838b1ad06a91ac72.png';

export const PROJECT_STEP_ACTIVE_BG_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-8ee717f58d2b4e258a387c801ef1187c.png';

export const RANK_CUP_ICON_1_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-0f8e4b285ee24f25a2868c2203241f77.png';
export const RANK_CUP_ICON_2_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-8a5ead41314d4a0db3fc99c624d9696a.png';
export const RANK_CUP_ICON_3_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-aeec374231df455fa963ad54471bf8d5.png';

export const SYMBOL_ICON_MORE_CHAINS =
  '/bybit/deadpool/image-daf8d7b738294d5c874b00593bb17fdd.png';

export const RANK_TIP_ICON_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-7d843ed03a0b45ebb7c2501ed4ca4423.png';

export const RANK_STEP_ACTIVE_RING_IMG =
  'https://s1.bycsi.com/bybit/deadpool/image-1ae142020e474a0b8057746969ce4dde.svg';

export const PRICE_POOL_CONTENT_EXTEND_IMG =
  '/bybit/deadpool/image-e82d1b4b688c4b94bb725c1f20071406.svg';

export const PORJECT_LIST_RANK_1_IMG =
  '/bybit/deadpool/image-f2a6ca96e72746c59a266047a5fdb932.png';
export const PORJECT_LIST_RANK_2_IMG =
  '/bybit/deadpool/image-c16185f2a41d4b3180868242d1fed417.png';
export const PORJECT_LIST_RANK_3_IMG =
  '/bybit/deadpool/image-438e071b4b3a41d390d5e1272604b3d6.png';

export const DEFAULT_PROJECT_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-a21d8f6f2af845628ce9abfd864bf124.svg';

export const HOME_POPUP_BONUS_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-3386a1ba8b384042a2163b3a66d81fa4.png';

export const JOIN_SUCESS_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-265b21eb27d345e0b94c21a0790651a1.png';

export const RANK_FOUR_PROJECT_TAG =
  'https://s1.bycsi.com/bybit/deadpool/image-b6a6522d067c49b68badec63c50e213d.png';

export const WINNER_EMPTY_Q =
  'https://s1.bycsi.com/bybit/deadpool/image-0045963d5f504c649f1817a632fac7b8.svg';

export const UNSUPPORTED_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-e7d6b555f1c64971923479445a54f3b9.svg';

export const HELP_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-70952b2677114e3d9845709b365709cd.svg';

export const USDT_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-1727c8295e3944d496c63c6cfcbf4595.png';

export const BBSOL_ICON =
  'https://s1.bycsi.com/bybit/deadpool/image-b168ae32ea0b45be837dc20adcf7b7a2.png';

export const enum RankType {
  POINTS = 'points',
  TRACK = 'track',
  CHAIN = 'chain',
}

export const allowedWalletTypes = [
  WalletType.CLOUD,
  WalletType.MPC,
  WalletType.MNEMONIC_PHRASE,
];

export const REFRESH_REMIND_TIME = 20;

export const OTHERS_CHAIN_KEY = 'CUSTOM_OTHERS_CHAIN_CODE';
